import React from 'react'
import ModalFormUI from '../../../widgets/form/ModalFormUI'
import InputTextAreaSF from '../../../widgets/form/InputTextAreaSF'

const RequestDescUpdateModalUI = ({
  context, successMsg, errorList, setErrorList,
  // modes
  updateMode, submitted,
  // event handlers
  onSubmit, onCancelClick,
  // fields
  requestDescription, onRequestDescriptionChange, requestDescriptionError, setRequestDescriptionError
}) =>
  <ModalFormUI
    context={context}
    titleLabel='Update Loan Purpose'
    buttonLabel='Update'
    cancelLabel='Cancel'
    isOpen={updateMode}
    onRequestClose={onCancelClick}
    successMsg={successMsg}
    errorList={errorList}
    setErrorList={setErrorList}
    onSubmit={onSubmit}
    busy={submitted}
  >
    <InputTextAreaSF
      name='requestDescription'
      label='Loan Purpose'
      value={requestDescription}
      onChange={onRequestDescriptionChange}
      error={requestDescriptionError}
      setError={setRequestDescriptionError}
      required={true}
    />
  </ModalFormUI>

export default RequestDescUpdateModalUI
